export const isSSR = (): boolean => typeof window === 'undefined';
export const isProd = (): boolean => process.env.ENV === 'prod';

export const getCurrentLoB = (): 'health100' | 'cvs' => {
  if (isSSR()) return 'cvs';
  const host = window?.location?.hostname;
  const searchParams = new URLSearchParams(window?.location?.search);
  if (host?.includes('health100') || searchParams.get('lob') === 'health100') {
    return 'health100';
  }
  return 'cvs';
};

export const getCurrentEnv = (): string => {
  if (isSSR()) {
    if (process.env?.ENV === null || process.env?.ENV === undefined) {
      if (process?.env?.NEXT_PUBLIC_APP_ENV === 'lighthouse' || process?.env?.NEXT_PUBLIC_APP_ENV === 'pa11y') {
        return 'QA2';
      } else {
        return '';
      }
    }
    const environment = process.env.ENV.toUpperCase();
    switch (process.env.ENV) {
      case 'local':
        return 'LOCAL';
      case 'prod':
      case 'prod-west':
        return 'PROD';
      default:
        return environment ? environment : 'PROD';
    }
  }
  const host = window?.location?.hostname;
  const prodHost = ['m.cvs.com', 'www.cvs.com'];
  if (prodHost.indexOf(host) > -1) return 'PROD';
  let env = 'QA2';
  if (host.includes('localhost')) {
    env = 'LOCAL';
  }
  if (host.includes('qa-csr')) {
    env = 'QA2-CSR';
  } else if (host.includes('preview')) {
    env = 'PREVIEW';
  } else if (host?.split('-')?.length > 1) {
    env = host.split('-')[1]?.split('.')[0]?.toUpperCase();
  }
  return env ? env : 'PROD';
};

export const getLDQueryParams = () => {
  if (isSSR()) {
    return;
  }
  const searchParam = window?.location?.search;
  const urlParams = new URLSearchParams(searchParam);
  return urlParams.get('location');
};

/**
 *
 * @param url
 * @param tag
 * @returns void
 * @description util functon to load run time js file.
 */
export const loadScript = (url: string, tag: string) => {
  return new Promise<any>((resolve, reject) => {
    if (!document) return;
    if (document.getElementById(tag)) return true;
    const s = document.createElement('script') as HTMLScriptElement;
    s.src = url;
    s.id = tag;
    document.body.appendChild(s);
    s.async = true;
    s.onload = (e) => {
      resolve(e);
    };
    s.onerror = (e) => {
      reject(e);
    };
  });
};

export const validateDate = (month?: string, day?: string, year?: string) => {
  if (month?.trim() === '' && day?.trim() === '' && year?.trim() === '') return false;
  const validator = [false, false, false];
  if (Number(month) > 12) validator[0] = true;
  if (Number(day) > 31) validator[1] = true;
  return validator;
};

export const validateYear = (dateOfReview: string) => {
  const today = new Date();
  const reviewDate = new Date(dateOfReview);
  let age = today.getFullYear() - reviewDate.getFullYear();
  const m = today.getMonth() - reviewDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < reviewDate.getDate())) {
    age--;
  }
  return age < 5;
};

export const datePatternMatch = (month: string, day: string, year: string) => {
  if (month.length < 2) month = 0 + month;
  if (day.length < 2) day = 0 + day;
  const date = `${month}/${day}/${year}`;
  return /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/.test(date);
};

export const formatReviewDate = (iso: string): string =>
  new Date(`${iso}T00:00:00`).toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  });

export const isFutureDate = (date: string): boolean => {
  const enteredDate = new Date(date);
  const currentDate = new Date();
  return enteredDate > currentDate;

};

export const onlyNumberKey = (event: any) => {
  // allow copy, paste, select all etc.
  if (event.metaKey || event.controlKey) {
    return;
  }
  // allow shift, delete, tab etc.
  if (event.key?.length > 1) return;
  // don't allow any key except numbers.
  const regex = /[0-9]/;
  if (!regex.test(event.key)) event.preventDefault();
};

export const addZero = (event: any) => {
  if (event.target.value < 1) return;
  if (event.target.value.length < 2) event.target.value = 0 + event.target.value;
};

export const shortenUrl = (url: string): string => {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, '');
    const xid = parsed.searchParams.get('xid');
    const path = xid ? `/appsurvey/${xid}` : '';
    return `${parsed.protocol}//${host}${path}`;
  } catch {
    return url;
  }
};
